import React from "react";
import { FaIndianRupeeSign } from "react-icons/fa6";

// Reusable Stats Card (Icon Type)
const StatsCard = ({ title, subtitle, icon: Icon, value }) => (
  <div className="flex flex-col gap-3 bg-background_2/80 px-5 py-4 rounded-3xl w-full">
    <div className="flex flex-col gap-1">
      <h1 className="md:text-headline4 text-subtitle1 font-nunito text-secondary/90 font-bold">
        {title}
      </h1>
      <p className="text-secondary/60 font-ptsans text-body2">{subtitle}</p>
    </div>
    <div className="flex flex-row items-center gap-2 p-2 bg-background/80 rounded-xl overflow-hidden">
      {/* Icon (Always Visible) */}
      {Icon && (
        <div className="flex justify-center items-center bg-secondary/80 lg:h-16 h-12 lg:text-headline4 text-subtitle2 text-background rounded-lg aspect-square">
          <Icon />
        </div>
      )}
      {/* Value */}
      <div className="flex justify-start items-center flex-1">
        <h2 className="lg:text-headline5 text-subtitle1 font-nunito text-secondary/80 font-bold flex items-center">
          <FaIndianRupeeSign />
          {value}
        </h2>
      </div>
    </div>
  </div>
);

// Reusable Progress Card
const ProgressCard = ({ title, subtitle, current, total, label }) => {
  const percent = total > 0 ? ((current / total) * 100).toFixed(1) : "0.0";

  return (
    <div className="flex flex-col gap-2 bg-background_2/80 px-5 py-4 rounded-3xl w-full">
      <div className="flex flex-col gap-1">
        <h1 className="md:text-headline4 text-subtitle1 font-nunito text-secondary/90 font-bold">
          {title}
        </h1>
        <p className="text-secondary/60 font-ptsans text-body2">{subtitle}</p>
      </div>
      <div className="flex items-center gap-4 rounded-lg">
        {/* Circular Progress */}
        <div className="relative w-20 h-20">
          <svg className="w-full h-full -rotate-90" viewBox="0 0 36 36">
            <circle
              cx="18"
              cy="18"
              r="16"
              className="stroke-background_2/95"
              strokeWidth="3"
              fill="none"
              strokeLinecap="round"
            />
            <circle
              cx="18"
              cy="18"
              r="16"
              className="stroke-primary/80"
              strokeWidth="3"
              strokeDasharray="100"
              strokeDashoffset={100 - percent}
              fill="none"
              strokeLinecap="round"
            />
          </svg>
          <div className="absolute inset-0 flex items-center justify-center md:text-body1 text-body2 font-nunito font-bold text-secondary/80">
            {percent}%
          </div>
        </div>
        {/* Progress Details */}
        <div className="flex-1">
          <p className="text-body1 font-ptsans text-secondary/80">
            <b>{current}</b> Out of <b>{total}</b> {label}
          </p>
        </div>
      </div>
    </div>
  );
};

// Main Stats Matrix Component
const StatsMatrix = ({ cards }) => {
  return (
    <div className="w-full">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 w-full">
        {cards.map((card, index) => {
          if (card.type === "icon") {
            return <StatsCard key={index} {...card} />;
          } else if (card.type === "progress") {
            return <ProgressCard key={index} {...card} />;
          }
          return null;
        })}
      </div>
    </div>
  );
};

export default StatsMatrix;
